import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

import { MIDDLE_MARGIN, SMALL_MARGIN } from '../../../../theme';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    form: {
      textAlign: 'center',
      marginTop: MIDDLE_MARGIN,
      width: 328,
    },
    formFieldWrap: {
      width: '100%',
      marginBottom: 24,
      '&:nth-child(2)': {
        marginBottom: MIDDLE_MARGIN,
      },
      [theme.breakpoints.down('xs')]: {
        padding: `0 ${SMALL_MARGIN}px`,
      },
    },
    formField: {
      width: '100%',
    },
  }),
);

export default useStyles;
